// "Shop the look" -- the rail of room scenes, plus the one thing the rail
// itself knows nothing about: the markers.
//
// Everything about scrolling, paging and the overflow-driven arrows comes
// from kludi-rail.js. This class adds the markers and the rule that only one
// of them is ever open: two cards are 300px wide over a 1080px scene, so a
// second open card would sit on top of the first as often as not.
class KludiShopTheLook extends window.KludiRail {
  connectedCallback() {
    this.dots = Array.from(this.querySelectorAll('[data-kludi-look-dot]'));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.toggle(dot));
    });

    // a card is dismissed the way any transient overlay is: Escape from
    // inside it, or a click anywhere that is not this component
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = this.dots.find((dot) => dot.getAttribute('aria-expanded') === 'true');
      if (!open) return;
      event.stopPropagation();
      this.close(open);
      open.focus();
    });

    this._onDocumentPointerDown = this._onDocumentPointerDown.bind(this);
    document.addEventListener('pointerdown', this._onDocumentPointerDown);

    // a marker that scrolls out of view keeps its card, and the card would
    // then be the only thing visible from a scene nobody is looking at
    this.addEventListener('scroll', () => this.closeAll(), { capture: true, passive: true });

    this.initRail();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('pointerdown', this._onDocumentPointerDown);
  }

  _onDocumentPointerDown(event) {
    if (this.contains(event.target)) return;
    this.closeAll();
  }

  card(dot) {
    return this.querySelector(`#${CSS.escape(dot.getAttribute('aria-controls'))}`);
  }

  toggle(dot) {
    if (dot.getAttribute('aria-expanded') === 'true') {
      this.close(dot);
      return;
    }

    this.closeAll();
    dot.setAttribute('aria-expanded', 'true');
    const card = this.card(dot);
    if (card) card.hidden = false;
  }

  close(dot) {
    dot.setAttribute('aria-expanded', 'false');
    const card = this.card(dot);
    if (card) card.hidden = true;
  }

  closeAll() {
    this.dots.forEach((dot) => {
      if (dot.getAttribute('aria-expanded') === 'true') this.close(dot);
    });
  }
}

window.customElements.define('kludi-shop-the-look', KludiShopTheLook);
